module.exports = __webpack_public_path__ + "static/media/futuristic-house.02bf705e.jpg";